/**
 * Icon mapping for notification types / categories (MUI icons).
 */

import {
  PersonOutline,
  RequestQuoteOutlined,
  LocalShippingOutlined,
  PaymentOutlined,
  PhoneInTalkOutlined,
  EventNoteOutlined,
  FeedbackOutlined,
  WarningAmberOutlined,
  NotificationsNoneOutlined,
  SupportAgentOutlined,
  DirectionsCarOutlined,
  CheckCircleOutline,
  ListAltOutlined,
  DnsOutlined,
} from "@mui/icons-material";
import { isPaymentNotification, resolveNotificationCategory } from "./taxonomy.js";

export const getNotificationIconComponent = (notification) => {
  if (isPaymentNotification(notification)) return PaymentOutlined;

  switch (notification?.entityType) {
    case "lead":
      return PersonOutline;
    case "quote":
      return RequestQuoteOutlined;
    case "order":
      return LocalShippingOutlined;
    case "call_request":
      return PhoneInTalkOutlined;
    case "followup":
      return EventNoteOutlined;
    case "feedback":
      return FeedbackOutlined;
    case "driver":
    case "vehicle":
      return DirectionsCarOutlined;
    case "agent_conversation":
      return SupportAgentOutlined;
    case "system":
      return DnsOutlined;
    default:
      break;
  }

  if ((notification?.type || "").includes("error")) {
    return WarningAmberOutlined;
  }

  return NotificationsNoneOutlined;
};

export const getCategoryIconComponent = (categoryId) => {
  switch (categoryId) {
    case "action_required":
      return WarningAmberOutlined;
    case "leads":
      return PersonOutline;
    case "quotes":
      return RequestQuoteOutlined;
    case "payments":
      return PaymentOutlined;
    case "operations":
      return LocalShippingOutlined;
    case "system":
      return DnsOutlined;
    case "updates":
      return ListAltOutlined;
    case "read":
      return CheckCircleOutline;
    default:
      return NotificationsNoneOutlined;
  }
};

export const getAccentForNotification = (notification, accents) => {
  if (!notification?.isRead && (notification?.priority === "urgent" || notification?.priority === "high")) {
    return accents.action_required;
  }
  const category = resolveNotificationCategory(notification);
  return accents[category] || accents.all;
};
